import { createNavigationContainerRef } from '@react-navigation/native';
import { RootStackParamList } from '../types/navigation';

export const navigationRef = createNavigationContainerRef<RootStackParamList>();

export function navigate(name: keyof RootStackParamList, params?: any) {
  if (navigationRef.isReady()) {
    // @ts-ignore - Type safety is handled by the ref
    navigationRef.navigate(name, params);
  }
}

export function goBack() {
  if (navigationRef.isReady() && navigationRef.canGoBack()) {
    navigationRef.goBack();
  }
}

/**
 * Leave whatever is on screen and show Sign In. Used when the server says
 * the session is over (a 401 carrying SIGN_IN_REQUIRED), after the session
 * has been wiped. No-op until the navigator is ready.
 */
export function resetToLogin(): void {
  if (!navigationRef.isReady()) return;
  navigationRef.resetRoot({
    index: 0,
    routes: [{ name: 'Auth', state: { routes: [{ name: 'Login' }] } } as any],
  });
}
